<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 18:09:48
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-loading="isloading" class="my-container">
    <div class="my-title">基础信息</div>
    <div class="my-content">
      <el-form ref="form" :model="form" class="sub-form" style="margin-top: 20px">
        <el-form-item label="头像：" prop="Avatar">
          <el-upload class="avatar-uploader" :headers="upload.headers" :action="upload.url" :show-file-list="false"
            accept=".jpeg,.jpg,.gif,.png" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <div v-if="form.Avatar" class="avatar-box">
              <img :src="form.Avatar" class="avatar" />
              <button class="avatar-editor-btn">更改</button>
            </div>
            <div v-else class="avatar-no-box">
              <img src="../../../assets/img/image.png" class="avatar-no-icon" />
              <div class="avatar-no-text">更换头像</div>
            </div>
          </el-upload>
        </el-form-item>
        <div class="relative">
          <el-form-item label="昵称：" prop="NickName">
            <el-input v-model="form.NickName" placeholder="请输入昵称" maxlength="28" />
          </el-form-item>
          <span class="tit">昵称限制字数最长28个字符</span>
        </div>
        <div class="relative">
          <el-form-item label="姓名：" prop="RealName">
            <el-input v-model="form.RealName" @change="showNameTips = false" placeholder="请输入姓名" />
          </el-form-item>
          <span v-if="showNameTips" class="tit">申请成为管理者此项必填</span>
        </div>
        <el-form-item label="性别：">
          <el-radio-group v-model="form.Sex">
            <el-radio :label="1"> 男 </el-radio>
            <el-radio :label="2"> 女 </el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="relative">
          <el-form-item label="身份证号：" prop="IDCard">
            <el-input v-model="form.IDCard" @change="showTips = false" placeholder="请输入身份证号" />
          </el-form-item>
          <span v-if="showTips" class="tit">申请成为管理者此项必填</span>
        </div>
        <el-form-item label="所属单位：" prop="OrgnID" class="width900">
          <el-select :value="form.OrgnID" @change="handleChangeOrgnId" placeholder="选择已有单位" class="width300">
            <el-option v-for="it in orgList" :key="it.OrgnID" :label="it.OrgnName" :value="it.OrgnID" />
          </el-select>

          <el-button v-if="form.ManagerApplyStatus == 0 && !form.IsManager" class="applyOrg-btn" @click="applyOrg">
            申请成为单位管理者
          </el-button>
          <el-button v-if="form.ManagerApplyStatus == 1 && !form.IsManager" class="applyOrg-btn" disabled>
            待审核
          </el-button>
          <el-button v-if="form.ManagerApplyStatus == 3 && !form.IsManager" class="applyOrg-btn applyOrg-btn2"
            @click="applyOrg">
            重新申请成为单位管理者
          </el-button>
        </el-form-item>
        <el-form-item label="单位管理者：">
          {{ form.IsManager == true ? "是" : "否" }}
        </el-form-item>
        <el-form-item label="合作者：">
          {{ form.IsPartner == true ? "是" : "否" }}
        </el-form-item>
        <el-form-item label="银行名称：" prop="BankName">
          <el-input v-model="form.BankName" placeholder="请输入银行名称" />
        </el-form-item>
        <el-form-item label="银行卡号：" prop="BankCardNo">
          <el-input v-model="form.BankCardNo" placeholder="请输入银行卡号" />
        </el-form-item>
        <el-form-item label=" ">
          <el-button class="submit-btn" @click="submit"> 完成 </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getToken, setToken, removeToken } from "@/util/auth";

import Bus from "@/util/bus";
import {
  GetOrgns,
  GetUserInfo,
  ApplyManager,
  SaveUserInfo,
} from "@/api/member";
/* eslint-disable */
export default {
  name: "info",
  data() {
    return {
      fileType: ["jpg", "jpeg", "png", "gif"],
      orgList: [],
      isloading: true,
      showTips: false,
      showNameTips: false,
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: "",
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Token: getToken() },
        // 上传的地址
        url: this.baseUrl + "/pc/Common/UploadImage?modName=avatar",
      },
      form: {
        Avatar: "",
        RealName: "",
        NickName: "",
        Sex: 1,
        IDCard: "",
        Phone: "",
        OrgnID: "",
        IsManager: false,
        IsPartner: false,
        BankName: "",
        BankCardNo: "",
      },
    };
  },

  mounted() {
    this.getOrg();
    this.getInfo();
  },

  methods: {
    handleChangeOrgnId(e) {
      console.log("handleChangeOrgnId", e);
      if (this.form.OrgnID) {
        this.$alert(
          "您当前已有加入的单位。同一时间仅能存在一个单位身份，切换单位后将自动解除与原单位的管理者关系，是否确认切换？",
          "提示",
          {
            cancelButtonText: "取消",
            confirmButtonText: "确定",
            showCancelButton: true,
            callback: (action) => {
              if (action == "confirm") {
                this.form.OrgnID = e;
              }
              console.log("handleChangeOrgnId", action);
            },
          }
        );
      } else {
        this.form.OrgnID = e;
      }
    },
    applyOrg() {
      if (!this.form.RealName) {
        this.showNameTips = true
      }
      if (!this.form.IDCard) {
        this.showTips = true
      }
      if (!this.form.RealName || !this.form.IDCard) {
        return false;
      }
      ApplyManager().then((res) => {
        if (res.code == 0) {
          this.$message.success("申请成功");
          this.getInfo();
        }
      });
    },
    submit() {
      let formData = {
        ...this.form,
      };
      if (!formData.OrgnID) {
        formData.OrgnID = 0;
      }

      SaveUserInfo(formData).then((res) => {
        if (res.code == 0) {
          this.$message.success("编辑成功");
          this.getInfo(true);
        }
      });
    },
    getOrg() {
      GetOrgns().then((res) => {
        this.orgList = res.data;
      });
    },
    getInfo(flag) {
      this.isloading = true;
      GetUserInfo()
        .then((res) => {
          this.isloading = false;
          this.$store.state.userInfo = {
            ...this.$store.state.userInfo,
            ...res.data,
          };
          if (flag) {
            this.$emit("update");
            Bus.$emit("updateAvater", "updateAvater");
          }
          this.form = { ...this.form, ...res.data };
          this.form.OrgnID = res.data.OrgnID || "";
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.form.Avatar = res.data.FilePath;
      } else {
      }
    },

    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      // 校检文件类型
      if (this.fileType) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        const isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `图片格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-form {
  width: 450px;
}

::v-deep .el-form-item {
  display: flex;
}

::v-deep .el-form-item__label {
  width: 120px;
}

.width900 {
  width: 900px;
}

::v-deep.avatar-uploader .el-upload {
  /* border: 1px dashed; */
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid #e6e6e6;
  background-color: #f6f6f6;
  width: 130px;
  height: 130px;
  line-height: 130px;

  .avatar-box {
    width: 100%;
    height: 100%;
    position: relative;

    .avatar-editor-btn {
      position: absolute;
      bottom: 15%;
      left: 50%;
      transform: translateX(-50%);
      color: #ffffff;
      background: #1d79ff;
      padding: 4px 12px;
      cursor: pointer;
      border-radius: 8px;
    }

    img {
      width: 100%;
      height: 100%;
      border-radius: 130px;
    }
  }

  .avatar-no-box {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .avatar-no-icon {
      width: 30px;
      height: 24px;
      margin-bottom: 13px;
    }

    .avatar-no-text {
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      font-size: 16px;
      line-height: 1;
      color: #cccccc;
    }
  }
}

//修改选中radio背景色、边框
//点击前的样式
::v-deep .el-input__inner {
  width: 300px;
  height: 46px;
}

::v-deep .el-radio__label {
  font-size: 16px;
}

::v-deep .el-radio__inner {
  border-radius: 50%;
  width: 26px;
  height: 26px;
}

//点击后的样式
::v-deep .el-radio__inner::after {
  width: 26px;
  height: 26px;
  //让圆框变成方框
  border-radius: 50%;
  //点击后方框中的图片
  background: url("~@/assets/img/home/61.png") no-repeat;
  background-size: 100% 100%;
  border: none;
  //图片适应方式
  ///background-size：contain，
  //background-size:150px 80px;
  //background-size:cover;
  //background-size:40% 60%;
}

.my-container {

  // height: 810px;
  .my-title {
    font-size: 18px;
    color: #333333;
    padding: 0 25px;
    height: 68px;
    line-height: 68px;
    background: #ffffff;
    border-radius: 10px;
  }

  .my-content {
    padding: 25px;
    margin-top: 1px;
    // height: 810px;
    background: #ffffff;
    border-radius: 10px;
  }
}

.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}

.applyOrg-btn {
  width: 200px;
  height: 46px;
  margin-left: 10px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 16px;
  color: #ffffff;
}

.applyOrg-btn2 {
  width: 220px;
}

.tit {
  position: absolute;
  right: -175px;
  top: 12px;
  font-weight: 400;
  font-size: 16px;
  color: #d13d3d;
}
</style>
